import { api } from './client'

/** "Act as organisation" — audited, read-only, time-boxed platform support access. */
export interface SupportAccess {
  active: boolean
  id?: string
  organization?: { id: string; name: string | null }
  reason?: string
  mode?: string
  read_only?: boolean
  started_at?: string
  expires_at?: string
}

export async function getSupportAccess(): Promise<SupportAccess> {
  return (await api.get('/api/v1/me/act-as')).data as SupportAccess
}

export async function startSupportAccess(orgId: string, body: { reason: string; password: string; ttl_minutes: number }): Promise<SupportAccess> {
  return (await api.post(`/api/v1/admin/organizations/${orgId}/act-as`, body)).data as SupportAccess
}

export async function endSupportAccess(): Promise<void> {
  await api.delete('/api/v1/me/act-as')
}

export interface OrgOption { id: string; name: string }

export async function listOrganisationsForSupport(): Promise<OrgOption[]> {
  const data = (await api.get('/api/v1/admin/organizations', { params: { per_page: 100 } })).data as { items?: OrgOption[] }
  return (data.items ?? []).map((o) => ({ id: String(o.id), name: String(o.name) }))
}
